import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import LOGO from './assets/full_white.png';
import './ClaimGift.css';

function ClaimGift() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') || '';

  const deepLink = code
    ? `dropora:///claim-gift?code=${encodeURIComponent(code)}`
    : `dropora:///claim-gift`;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);

  const tryOpen = () => {
    // Tente d'ouvrir via le scheme custom
    window.location.href = deepLink;

    // Si l'app n'est pas installée, redirige vers le store après 2s
    setTimeout(() => {
      if (document.hidden || document.webkitHidden) return;
      if (isIOS) {
        window.location.href = 'https://apps.apple.com/us/app/dropora/id6478829126';
      } else if (isAndroid) {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.qwrtx.dropora';
      }
    }, 2000);
  };

  // Ouverture automatique au chargement
  useEffect(() => {
    const timer = setTimeout(tryOpen, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="claim-gift-container">
      <img src={LOGO} alt="Dropora" className="logo" />
      <div className="subtitle">Un cadeau t'attend dans l'app !</div>

      <button className="btn" onClick={tryOpen}>
        Ouvrir dans Dropora
      </button>

      <div className="store-links">
        <a className="store-btn" href="https://apps.apple.com/us/app/dropora/id6478829126">
          App Store
        </a>
        <a className="store-btn" href="https://play.google.com/store/apps/details?id=com.qwrtx.dropora">
          Google Play
        </a>
      </div>

      <p className="msg">Si l'app ne s'ouvre pas, télécharge-la puis reviens sur ce lien.</p>
    </div>
  );
}

export default ClaimGift;
